import { useMemo } from 'react';

import { formatPrice } from 'src/common/helpers';
import type { Campaign } from 'src/common/interfaces/campaigns';
import { useGetUserQuery } from 'src/common/slices';
import { useGetSubscriptionPricingQuery } from 'src/features/pricing/pricing.slice';

export const useAbsoluteSavingAmount = (campaign: Campaign | null) => {
  const { data: pricingResponse } = useGetSubscriptionPricingQuery(false);
  const { data: userQueryData } = useGetUserQuery();
  const pricingData = pricingResponse?.data;

  return useMemo(() => {
    if (!pricingData || !userQueryData?.data?.user || !userQueryData?.data?.user?.isPremium || !campaign) {
      return null;
    }

    const { monthlyPlan, yearlyPlan } = pricingData;
    const annualSavingAbsolute = monthlyPlan.price * 12 - yearlyPlan.price + yearlyPlan.price * (campaign.amount / 100);

    return `${yearlyPlan.symbol}${formatPrice(annualSavingAbsolute)[0]!}`;
  }, [pricingData, userQueryData, campaign]);
};
